import React from 'react';
import {Helmet} from 'react-helmet';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Blurbs from '../components/Blurbs';
import * as Strings from '../constants';

export default () => (
  <header className="App-header">

      <Helmet>
        <title>{Strings.Page_About + " · " + Strings.Meta_PageTitle}</title>
      </Helmet>

    <Row>
      <Col md={4} className="pageTitle">
        <h1>{Strings.Page_About}</h1>
      </Col>
      <Col md={7} className="pageContent">

        <Blurbs page="about" />

      </Col>
    </Row>
  </header>
);



// WEBPACK FOOTER //
// ./src/pages/about.js